.footer {
  /* 84px bottom = the fixed Help button's 24px offset + 44px size + 16px gap,
     so scrolled to the end the row sits above the button instead of under it. */
  padding: 40px var(--page-padding) 84px;
  border-top: 1px solid var(--color-border-default);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.copyright {
  font-family: var(--font-body);
  font-size: 12px;
  color: var(--color-text-faint);
  letter-spacing: 0.04em;
}

.socials {
  display: flex;
  gap: 24px;
}

.socialLink {
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-muted);
  cursor: pointer;
  letter-spacing: 0.04em;
  transition: color var(--duration-fast);
  text-decoration: none;
}

.socialLink:hover {
  color: var(--neon-orange);
}

.legalDivider {
  width: 1px;
  height: 14px;
  background: var(--color-border-default);
  opacity: 0.5;
}

@media (max-width: 768px) {
  .footer {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 32px 16px;
    gap: 16px;
  }

  /* Icons + Privacy + Terms don't fit one 390px row; the divider becomes a
     line break so the links sit centered under the icons, clear of the
     fixed Help button in the corner. */
  .socials {
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 0;
  }

  .legalDivider {
    flex-basis: 100%;
    height: 0;
  }

  .socialLink {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }
}
